<template>
	<page-body>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-left:10px; padding-top:10px; padding-bottom:0px;">
      <el-form :inline="true" >
        <el-row :gutter="24">
        <el-col :span="5">
              <el-form-item label="起始日期:" >
                <el-date-picker v-model="startDate" type="date" placeholder="选择日期"  ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="终止日期:" >
                <el-date-picker v-model="endDate" type="date" placeholder="选择日期"  ></el-date-picker>
              </el-form-item>
            </el-col>
             <el-col :span="4">
            <el-form-item style='width:100%'  >
              <el-input style='width:300px' v-model="salesCustomer" placeholder="销售客户"  @change="getSales" ></el-input>
            </el-form-item>
            </el-col>
                     </el-row>
      </el-form>
            <el-form :inline="true" >
        <el-row :gutter="24">
            <el-col :span="10">
          <el-select multiple  style='margin-bottom:20px;width:100%'  v-model="name" filterable="" clearable remote placeholder="请输入商品名称" :remote-method="remoteMethod" >
                  <el-option v-for="item in items" :key="item.key" :label="item.label" :value="item.key">
                  </el-option>
              </el-select>
              </el-col>
			<el-col :span="3">
		 	<el-button style='float:left' type="primary" icon="search" @click="getSales()"></el-button>
		 	</el-col>
		 	<el-col :span="3">
		 	<el-button style='float:left' type="primary" icon="document" @click="handleDownload">导出excel</el-button>
		 	</el-col>
	  </el-row>
      </el-form>
      </el-col>
		<!--列表-->
		<el-table :data="sales"   border stripe :search-def='getSearchDef()' highlight-current-row v-loading="listLoading" @selection-change="selsChange" @row-click="rowClick" style="width: 100%;" >
			<el-table-column type="index" width="65">
			</el-table-column>
			<el-table-column prop="itemNo" label="商品编号" width="100" >
			</el-table-column>
			<el-table-column prop="itemName" label="商品名称" min-width="150" sortable>
			</el-table-column>
			<el-table-column prop="spec" label="商品规格" width="120" >
			</el-table-column>
			<el-table-column prop="manufacture" label="生产厂家" min-width="210" sortable>
			</el-table-column>
			<el-table-column prop="unit" label="单位" width="70">
			</el-table-column>
			<el-table-column prop="customerNo" label="客户编码" width="100">
			</el-table-column>
			<el-table-column prop="customerName" label="客户名称" min-width="150" sortable>
			</el-table-column>
			<el-table-column prop="salesQty" label="销售数量" width="100" >
			</el-table-column>
			<el-table-column prop="batchNo" label="批号" width="120" sortable>
			</el-table-column>
			<el-table-column prop="salesDate" label="销售日期" width="120"  sortable>
			</el-table-column>
			<el-table-column prop="salesName" label="销售员" width="100" sortable>
			</el-table-column>
			<el-table-column prop="address" label="送货地址" min-width="150" sortable>
			</el-table-column>
			<el-table-column prop="price" label="含税单价" width="100" v-if="userInfo.showMoney" >
			</el-table-column>
      <el-table-column prop="number" label="含税金额" width="100" v-if="userInfo.showMoney" >
      </el-table-column>
      <el-table-column prop="department" label="部门" width="100" >
      </el-table-column>
		</el-table>
			<!--工具条-->
		<el-col :span="24" class="toolbar">

			<el-pagination style="float:right;"
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="page"
		      :page-sizes="[5, 10, 15, 20 ,50]"
		      :page-size="pageSize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
		</el-col>
<el-dialog  v-model="viewVisible" width="90%" top = "2%" :show-close= true :fullscreen=true>
      <el-form :model="sales" label-width="70px" ref="resetForm"  class="table-expand">
          <el-form-item label="商品名称" >
            <span>{{ selectRow.itemName }}</span>
          </el-form-item>
          <el-form-item label="商品规格">
            <span>{{ selectRow.spec }}</span>
          </el-form-item>
          <el-form-item label="单位">
            <span>{{ selectRow.unit }}</span>
          </el-form-item>
          <el-form-item label="生产厂家">
            <span>{{ selectRow.manufacture }}</span>
          </el-form-item>
          <el-form-item label="客户名称">
            <span>{{ selectRow.customerName }}</span>
          </el-form-item>
          <el-form-item label="销售数量">
            <span>{{ selectRow.salesQty }}</span>
          </el-form-item>
          <el-form-item label="批号">
            <span>{{ selectRow.batchNo }}</span>
          </el-form-item>
          <el-form-item label="销售日期">
            <span>{{ selectRow.salesDate }}</span>
          </el-form-item>
          <el-form-item label="销售员">
            <span>{{ selectRow.salesName }}</span>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="viewVisible = false">返回</el-button>
      </div>
    </el-dialog>
	</page-body>

</template>
<script src="xlsx.full.min.js"></script>
<script>


	//import NProgress from 'nprogress'
	import { webapi, HTTP} from '../../api/api';
	import util from '../../common/js/util';
	import { export_json_to_excel } from '../../vendor/Export2Excel';
	export default {
		data() {
			return {
        viewVisible:false,
        startDate:new Date()- 3600 * 1000 * 24 ,
        endDate: new Date(),
				name: [],
        salesCustomer:'',
				pageSize:15,
				sales: [],
				items:[],
				total: 0,
        totalprice:0,
        totalNum:'',
        totalValue:'',
				page: 1,
				listLoading: false,
        selectRow:[],
				sels: [],//列表选中列
        userInfo:{}

			}
		},
		methods: {
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计金额';
            return;
          }
          if (index === 14) {
            sums[index] = this.totalprice;
            return;
          }

          // const values = data.map(item => Number(item[column.property]));
          // if (!values.every(value => isNaN(value))) {
          //   sums[index] = values.reduce((prev, curr) => {
          //     const value = Number(curr);
          //     if (!isNaN(value)) {
          //       return prev + curr;
          //     } else {
          //       return prev;
          //     }
          //   }, 0);
          //   sums[index] += ' 元';
          // } else {
          //   sums[index] = 'N/A';
          // }
        });
        return sums;
      },
			handleDownload() {
				var vm = this;
				let para = {
				};
				para.startTime = util.formatDate.format(new Date(vm.startDate), 'yyyy-MM-dd')
        para.endTime = util.formatDate.format(new Date(vm.endDate), 'yyyy-MM-dd')
				var uploadName = '';
				for(var i = 0; i <vm.name.length; i++){
					uploadName+= vm.name[i]+','
				}
				para.name =uploadName;
        para.salesCustomer = vm.salesCustomer
				webapi.post('/sales/findAll', para)
				  .then(function(response) {
				  	require.ensure([], () => {
			        const tHeader = ['序号', '商品编号', '商品名称', '商品规格', '生产厂家','单位','客户编码','客户名称','销售数量','销售部门','批号','销售员','送货地址','含税单价','含税金额','销售日期'];
			        const filterVal = ["id","itemNo","itemName","spec","manufacture","unit","customerNo","customerName","salesQty","salesDepartment","batchNo","salesName","address","price","number","salesDate"];
			        const list = response.data;
			        const data = vm.formatJson(filterVal, list);
			        export_json_to_excel(tHeader, data, '销售流向表');
			      })
				 }).catch((error) => {
				    vm.$message.error(error.response.data['message']);
				});

		    },
		    formatJson(filterVal, jsonData) {
		      return jsonData.map(v => filterVal.map(j => v[j]))
		    },

			remoteMethod(query) {
	          	var vm = this;
	            let para = {
	              params:{
                  offset: (vm.page-1)*vm.pageSize,
                  max: 500,
	                "queryParams": query,
	                "query":"itemName"
	              }
	            };
	            webapi.get('/item', para)
	            .then(function(response) {
	               //console.log(response.data.results)
	               vm.list = response.data.map(item => {
	                        return {key:item.id,value:item.itemName, label:item.itemNo+" "+item.itemName+" "+item.spec};
	                      });

	              vm.loading = false;
	              vm.items = vm.list
	            }).catch((error) => {
	            	vm.loading = false;
				    vm.$message.error(error.response.data['message']);
				});

        },
			// formatter: function (row, column) {
	  //     		return util.formatDate.format(row.salesDate, 'yyyy-MM-dd');
			// },
			handleSizeChange(val) {

				this.pageSize = val
				this.getSales();
				// this.getBranchWarehouse();
	        	// console.log(`每页 ${val} 条`);
	      	},
			handleCurrentChange(val) {
				this.page = val;
				this.getSales();
			},
			getSearchDef() {
			      return {
			        offset: 12,
			        placeholder: 'please input searchkey'
			        //,
			        //props: ['state', 'flow_type'] // can be string or Array
			      }
			    },
			getSales() {
				var vm = this;
				let para = {
					params:{
						offset: (vm.page-1)*vm.pageSize,
						max: vm.pageSize,
            salesCustomer:vm.salesCustomer
					}
				};
				vm.listLoading = true;
				//NProgress.start();
				para.params.startTime = util.formatDate.format(new Date(vm.startDate), 'yyyy-MM-dd')
        para.params.endTime = util.formatDate.format(new Date(vm.endDate), 'yyyy-MM-dd')
				var uploadName = '';
				for(var i = 0; i <vm.name.length; i++){
					uploadName+= vm.name[i]+','
				}
				para.params.name =uploadName;

				webapi.get('/sales', para)
				  .then(function(response) {
            if (response.data=="nopermission") {
              vm.$notify({
                  title: '警告',
                  message: '您的账户已到期,请联系管理员.',
                  type: 'warning'
                });
            }else{
              if (response.data.days<15&&response.data.days!=0) {
                vm.$notify.info({
                  title: '消息',
                  message: "您的账户还有"+response.data.days+"天到期."
                });
              }
				    vm.total = response.data.total;
            // vm.totalprice = response.data.totalprice.toFixed(2);
            // vm.totalNum = response.data.totalNum;
            // vm.totalValue = response.data.totalValue;
				    vm.sales = response.data.results;
          }
				    vm.listLoading = false;
				 }).catch((error) => {
					vm.listLoading = false;
				    vm.$message.error(error.response.data['message']);
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			rowClick:function(row, event){
				console.log(row)
        this.viewVisible = true
        this.selectRow = row
			},
      getUserInfo(){
        var vm = this;
        webapi.post('/user/getUserInfo', {}).then((res)=>{
          vm.userInfo = res.data
        })
      }
		},
		mounted() {
      this.getUserInfo()
			this.getSales();
			this.remoteMethod('');
		}
	}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SalesTable.vue?673f5196